import { z } from 'zod';
import { requiredString } from './common';

const reportRemarkFields = {
  code: requiredString('Code'),
  description: requiredString('Description'),
};

export const createReportRemarkSchema = z.object(reportRemarkFields);
export type CreateReportRemarkInput = z.infer<typeof createReportRemarkSchema>;

export const updateReportRemarkSchema = createReportRemarkSchema;
export type UpdateReportRemarkInput = z.infer<typeof updateReportRemarkSchema>;
